import {ListItem, ListWrapper, Title, Wrapper} from "./styles";
import {ToggleList} from "../ToggleList";
import hiw_1 from "assets/images/hiw_1.png";
import hiw_s_1 from "assets/images/hiw_s_1.png";
import hiw_2 from "assets/images/hiw_2.png";
import hiw_s_2 from "assets/images/hiw_s_2.png";
import hiw_3 from "assets/images/hiw_3.png";
import hiw_s_3 from "assets/images/hiw_s_3.png";
import {useTranslation} from "react-i18next";

export const HowItWorks = () => {
    const {t} = useTranslation('home');

    const hostState = [
        {
            src: hiw_1,
            text: t('howItWorks.host.p1.text'),
            title: t('howItWorks.host.p1.title'),
        },
        {
            src: hiw_2,
            text: t('howItWorks.host.p2.text'),
            title: t('howItWorks.host.p2.title'),
        },
        {
            src: hiw_3,
            text: t('howItWorks.host.p3.text'),
            title: t('howItWorks.host.p3.title'),
        },
    ];

    const studentState = [
        {
            src: hiw_s_1,
            text: t('howItWorks.student.p1.text'),
            title: t('howItWorks.student.p1.title'),
        },
        {
            src: hiw_s_2,
            text: t('howItWorks.student.p2.text'),
            title: t('howItWorks.student.p2.title'),
        },
        {
            src: hiw_s_3,
            text: t('howItWorks.student.p3.text'),
            title: t('howItWorks.student.p3.title'),
        },
    ];

    const render = (array: { src: string, title: string, text: string }[]) => {


        return array.map(({src, title, text}) => <ListItem>
            <div>
                <img src={src}/>
            </div>
            <div>
                <h2>
                    {title}
                </h2>
                <p>
                    {text}
                </p>
            </div>
        </ListItem>)
    }


    return (
        <Wrapper>
            <div>
                <Title>
                    {t('howItWorks.title.p1')}{' '}<span>{t('howItWorks.title.p2')}</span>
                </Title>
                <ListWrapper>
                    <ToggleList titles={[t('forHosts'), t('forStudents')]}
                                content={[render(hostState), render(studentState)]}/>
                </ListWrapper>
            </div>
        </Wrapper>
    )
}
